import React, { useState } from 'react';
import Header from '../../sections/Header';
import Banner from '../../sections/Banner';
import Footer from '../../sections/Footer';
import Breadcrumbs from '../../sections/Breadcrumbs';
import SectionHeaderWithButton from '../../composites/SectionHeaderWithButton';

const InitiativeThree: React.FC = () => {

  return (
  <>
    <Banner
              header={<Header />}
      breadcrumbs={<Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Initiatives', href: '/initiatives' }, { label: 'Ideas Incubator' }]} />}
      title={<span className="flex items-center">Ideas Incubator <span className="ml-4 inline-block rounded-full bg-teal-200 text-teal-700 text-sm font-semibold px-2 py-1 align-middle">Coming soon</span></span>}
      subtitle="We're building an incubator to shape and support the future of AI-driven ideas. Stay tuned."
      colorVariant="gradient"
      imageVariant="withImage"
      paddingVariant="default"
      showCTAs={false}
      showDefaultGraphic={true}
    />
    <div className="max-w-7xl mx-auto px-4 py-12">
      <SectionHeaderWithButton
        subheading="Initiative Three"
        title={<span className="flex items-center">Ideas Incubator <span className="ml-4 inline-block rounded-full bg-teal-200 text-teal-700 text-sm font-semibold px-2 py-1 align-middle">Coming soon</span></span>}
        description="We're building an incubator to shape and support the future of AI-driven ideas. Stay tuned."
      />
      <div className="mt-12 p-6 bg-gray-50 rounded-lg text-left border border-gray-100 shadow-sm">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">More Content Coming Soon</h3>
        <p className="text-gray-600 mb-2">
          We're currently building out the ideas incubator. Check back regularly for updates.
        </p>
      </div>
    </div>
    <Footer />
  </>
  );
};

export default InitiativeThree; 